async function getOrganizationData(customerId, cnpjR = null) {
  const token = await login();
  const url = cnpjR 
    ? `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/organizations?customerId=${customerId}&organizationRootDocument=${cnpjR}`
    : `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/organizations?customerId=${customerId}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Erro ao buscar dados de organizações.");
  }
  
  return response.json();
}

async function getOrganizationByCnpjWithLocations(customerId, cnpj) {
  const token = await login();
  const url = `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/organizations/companyLocations?customerId=${customerId}&cnpj=${cnpj}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Erro ao buscar empresa e locations pelo CNPJ.");
  }

  return response.json();
}

function renderOrganizationsData(organizations, container) {
  for (const organization of organizations) {
    const orgContainer = document.createElement("div");
    orgContainer.className = "dados dados-filial";

    const isSelected =
      `gid://shopify/Company/${globalCompanyId}` ===
      organization.shopifyCompanyId;

    orgContainer.innerHTML = `
        <label class="custom-checkbox">
          <input
            type="checkbox"
            name="checkbox-group"
            data-id="${organization.organizationId}"
            onclick="toggleCheckbox(this)"
            ${isSelected ? "checked" : ""}
          >
          <span></span>
        </label>
        <div class="filial-info">
          <p>${organization.companyName}</p>
          <span>
            ${organization.document.replace(
              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
              "$1.$2.$3/$4-$5"
            )}
          </span>
          <span>
            ${organization.billingAddress.city} / ${
      organization.billingAddress.state
    }
          </span>
        </div>
      `;

    container.appendChild(orgContainer);
  }

  removeMyAccountSpinner(container);
}

let currentCheckbox = null;
let isChangingOrganization = false;

function toggleCheckbox(clickedCheckbox) {
  if (isChangingOrganization) {
    clickedCheckbox.checked = clickedCheckbox === currentCheckbox;
    return;
  }

  if (currentCheckbox === null) {
    document
      .querySelectorAll('input[name="checkbox-group"]')
      .forEach((checkbox) => {
        if (checkbox.checked) {
          currentCheckbox = checkbox;
          return;
        }
      });
  }
  if (clickedCheckbox.checked) {
    document
      .querySelectorAll('input[name="checkbox-group"]')
      .forEach((checkbox) => {
        if (checkbox !== clickedCheckbox) {
          checkbox.checked = false;
        }
      });

    const previousCheckbox = currentCheckbox;
    currentCheckbox = clickedCheckbox;

    const organizationId = clickedCheckbox.getAttribute("data-id");
    changeOrganization(organizationId, clickedCheckbox, previousCheckbox);
  } else {
    clickedCheckbox.checked = true;
  }
}

function isTelesalesOrganizationChange() {
  return window.location.hash === "#alterar-empresa";
}

async function clearCart() {
  const response = await fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Erro ao limpar o carrinho.");
  }
}

function getCompanyLocationRedirectUrl(locationId) {
  const normalizedLocationId = String(locationId || "").split("/").pop();

  if (!/^\d+$/.test(normalizedLocationId)) {
    throw new Error("CompanyLocation inválida para concluir a troca de empresa.");
  }

  const params = new URLSearchParams({
    location_id: normalizedLocationId,
    return_to: "/pages/minha-conta",
  });

  return `/company_location/update?${params.toString()}`;
}

async function changeOrganization(
  organizationId,
  clickedCheckbox,
  previousCheckbox,
  selectedLocationId = null,
  triggerButton = null
) {
  if (isChangingOrganization) return;

  isChangingOrganization = true;
  if (triggerButton) triggerButton.disabled = true;

  const shouldClearCart = isTelesalesOrganizationChange();
  const spinnerOverlay = document.querySelector("#spinner-overlay");
  const spinnerContainer = document.querySelector(
    "#spinner-overlay .spinner-container"
  );

  spinnerOverlay.style.display = "flex";
  showMyAccountSpinner(spinnerContainer);

  try {
    const authorization = await login();

    if (shouldClearCart) {
      try {
        await clearCart();
      } catch (error) {
        console.error(error);
        showToast(
          "error",
          "Não foi possível limpar o carrinho para trocar a empresa.",
          "FECHAR"
        );

        if (clickedCheckbox) clickedCheckbox.checked = false;
        if (previousCheckbox) previousCheckbox.checked = true;

        currentCheckbox = previousCheckbox;
        return;
      }
    }

    const response = await fetch(
      `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/organizations/change?customerId=${globalCustomerId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authorization}`,
        },
        body: JSON.stringify({
          organizationId: organizationId,
        }),
      }
    );

    if (!response.ok) {
      console.error(await response.json());
      showToast("error", "Não foi possível alterar a sua filial!", "FECHAR");

      if (clickedCheckbox) clickedCheckbox.checked = false;
      if (previousCheckbox) previousCheckbox.checked = true;

      currentCheckbox = previousCheckbox;
      return;
    }

    const responseBody = await response.json().catch(() => null);

    if (isTelesalesOrganizationChange() && !selectedLocationId) {
      sessionStorage.setItem("pendingLocationSelectionAfterCompanyChange", "true");
    } else {
      sessionStorage.removeItem("pendingLocationSelectionAfterCompanyChange");
    }
    if (responseBody?.currentCompanyId) {
      sessionStorage.setItem("pendingCurrentCompanyId", String(responseBody.currentCompanyId));
    }
    if (responseBody?.currentLocationId) {
      sessionStorage.setItem("pendingCurrentLocationId", String(responseBody.currentLocationId));
    } else if (selectedLocationId) {
      sessionStorage.setItem("pendingCurrentLocationId", String(selectedLocationId));
    }
    sessionStorage.removeItem("companySyncRetryCount");
  } catch (error) {
    console.error(error);
    showToast("error", "Não foi possível alterar a sua filial!", "FECHAR");

    if (clickedCheckbox) clickedCheckbox.checked = false;
    if (previousCheckbox) previousCheckbox.checked = true;

    currentCheckbox = previousCheckbox;
    return;
  } finally {
    spinnerOverlay.style.display = "none";
    removeMyAccountSpinner(spinnerContainer);
    if (triggerButton) triggerButton.disabled = false;
    isChangingOrganization = false;
  }

  showToast("success", "Filial alterada com sucesso!", "FECHAR");
  const redirectUrl = selectedLocationId
    ? getCompanyLocationRedirectUrl(selectedLocationId)
    : "/pages/minha-conta";
  window.location.replace(redirectUrl);
}
